module.exports = __webpack_public_path__ + "static/design05-9139ca400a8966418471845272d6f297.png";